import React from 'react';
import '../css/jobRoleList.css';
import { ArrowUpRightIcon } from '../../../../../assets-module/asset-configuration/icon/iconExporter/iconExporter';
import { useNavigate } from 'react-router-dom';
import { JobRole } from './jobRole.type';
import { slugify } from '../../../../../route-module/route-configuration/controller-route/ts/slugifyRoute';

interface JobRoleListProps {
  jobs: JobRole[];
  className?: string;
  variant?: 'bordered' | 'borderless';
}

const JobRoleList: React.FC<JobRoleListProps> = ({ jobs, className = '', variant = 'borderless' }) => {
  const navigate = useNavigate()

  const onClickViewSpecJob = (jobName:string, codeId:string) => {
    navigate(`position/${slugify(jobName)}/code/${slugify(codeId)}`)
  }

  return (
    <div className={`scl--web-component-job-role-list-container ${className}`}>
      {jobs.map((job) => (
        <div //NOSONAR
          key={job.id}
          className={`scl--web-component-job-role-item ${variant === 'bordered' ? 'scl--web-component-job-role-item--bordered' : ''}`}
          onClick={()=>onClickViewSpecJob(job.id, job.code)}
        >
          <div className="scl--web-component-job-role-content">
            <div className="scl--web-component-job-role-title" >{job.title}</div>
            <div className="scl--web-component-job-role-location-wrapper">
              <span className="scl--web-component-job-role-location">{job.location}</span>
              <ArrowUpRightIcon width={24} height={24} />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default JobRoleList;
